module.exports = __webpack_public_path__ + "static/img/HomePlaying.70bda2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/UI_mock/1x/HomePlaying.png
// module id = fjDG
// module chunks = 1